import React from 'react';
import logoImage from '../assets/Logo.jpeg';

// --- Asset URLs ---
const LOGO_URL = logoImage;

// Keyframes are defined in a style tag for broader compatibility with CSS-in-JS.
const keyframes = `
    @keyframes logo-appear {
        from {
            opacity: 0;
            transform: scale(0.8);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }
    @keyframes text-appear {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

const SplashScreen = () => (
    <>
        <style>{keyframes}</style>
        <div style={styles.splashScreen}>
            <div style={styles.contentContainer}>
                <img src={LOGO_URL} alt="5RsPhysio Logo" style={styles.splashLogo} />
                <p style={styles.splashText}>
                    This is for my paati, ammamma and all the other grandparents of our beautiful country.
                </p>
            </div>
        </div>
    </>
);

// --- Styles ---
const styles = {
    splashScreen: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh', // Ensures it takes full screen height
        backgroundColor: '#FFFFFF', // Changed to white
    },
    contentContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '2rem',
    },
    splashLogo: {
        width: '250px',
        height: 'auto',
        marginBottom: '2rem',
        // Logo animation
        animation: 'logo-appear 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards',
    },
    splashText: {
        fontSize: '1.3rem',
        maxWidth: '450px',
        lineHeight: '1.7',
        color: '#0D47A1', // A deeper blue for better contrast
        fontWeight: '500',
        fontFamily: 'sans-serif',
        opacity: 0, // Start hidden
        // Text animation with a delay to follow the logo
        animation: 'text-appear 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.5s forwards',
    },
};

export default SplashScreen;
